
import './src/index.css'  // Make sure this line exists
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { applyLegacyHashRedirect } from './src/lib/legacyHashRedirect';

// Must run before BrowserRouter reads the location, or old `/#/en/...` links
// (already sent in emails, already bookmarked) would land on the home page.
applyLegacyHashRedirect(window.location, window.history);

const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
